import { useMemo } from 'react';
import { DefaultTheme } from '@mui/styles';
import {
  VictoryStyleObject,
  DomainPaddingPropType,
  PaddingProps
} from 'victory-core';

type ClassificationChartStyles = {
  VictoryChart: {
    height: number;
    domainPadding: DomainPaddingPropType;
    padding: PaddingProps;
  };
  VictoryBar: { barWidth: number; color: { [key: string]: string } };
  VictoryAxis: {
    style: { axis: VictoryStyleObject };
  };
};

export const useChartStyles = (
  theme: DefaultTheme
): ClassificationChartStyles => {
  return useMemo(
    () => ({
      VictoryChart: {
        height: parseInt(theme.spacing(11)),
        domainPadding: { x: [30, 30], y: [0, 0] },
        padding: { left: 80, right: 60 }
      },
      VictoryBar: {
        barWidth: parseInt(theme.spacing(2)),
        color: {
          ACCEPTED: '#dae9c4',
          UNCLASSIFIED: '#d2dafc',
          PRIVATE: '#fcdcae'
        }
      },
      VictoryAxis: {
        style: {
          axis: { stroke: 'transparent' },
          tickLabels: {
            fill: theme.palette.insights.classificatonLabel,
            textAnchor: 'start',
            ...theme.typography.body2
          }
        }
      }
    }),
    [theme]
  );
};
